import BaseNetwork from "@/lib/classes/BaseNetwork";
import { derivePubkeyFromXpub } from "@/lib/helpers/derive";
import { sha256 } from "@noble/hashes/sha256";
import { ripemd160 } from "@noble/hashes/ripemd160";

import { encodeAccountID } from "ripple-address-codec";

class XRP extends BaseNetwork {
  constructor(xpub: string) {
    super("XRP", xpub);
  }

  getAddress(index: number, derivationPath: number[], xpub: string): string {
    const pubkey = derivePubkeyFromXpub(xpub, [...derivationPath, index]);

    const address = encodeAccountID(
      ripemd160(sha256(Buffer.from(pubkey.compressed, "hex"))),
    );

    return address;
  }
}

export default XRP;
